import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const CategoryCard = ({ img, title, tagline, to, size = 'normal' }) => (
  <Link to={to} className={`group relative rounded-2xl overflow-hidden bg-white ${size === 'tall' ? 'flex flex-col h-full row-span-2' : 'block'}`}>
    <div className={`card-img-wrap ${size === 'tall' ? 'flex-1 h-full min-h-[420px]' : 'h-[280px]'}`}>
      <img
        src={img}
        alt={`${title} - Curated gift hampers by WrapYourWish`}
        width="600"
        height="420"
        loading="lazy"
        className="primary w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
    </div>
    <div className="absolute inset-0 p-6 flex flex-col justify-end">
      <h3 className="font-serif-display text-white text-2xl md:text-3xl leading-tight">{title}</h3>
      {tagline && <p className="text-white/85 text-sm mt-1">{tagline}</p>}
      <div className="mt-3 inline-flex items-center gap-2 text-white text-xs uppercase tracking-widest opacity-90 group-hover:opacity-100">
        Explore <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </div>
    </div>
  </Link>
);

const CorporateCategoryGrid = ({ items }) => {
  return (
    <section className="py-16 md:py-24 bg-[#FAF6F1]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <div className="text-xs uppercase tracking-[0.24em] text-[#C58B76] mb-3">Corporate Gifting</div>
            <h2 className="font-serif-display text-4xl md:text-5xl text-[#2C2416] max-w-2xl leading-tight">Every corporate moment, thoughtfully wrapped</h2>
          </div>
          <p className="text-[#5B4A3A] max-w-md leading-relaxed">From the day someone joins your team to the day they say goodbye - our hampers mark every meaningful milestone.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-5">
          <CategoryCard to={`/category/corporate/${items[0].id}`} img={items[0].hero} title={items[0].title} tagline={items[0].tagline} size="tall" />
          <CategoryCard to={`/category/corporate/${items[1].id}`} img={items[1].hero} title={items[1].title} tagline={items[1].tagline} />
          <CategoryCard to={`/category/corporate/${items[2].id}`} img={items[2].hero} title={items[2].title} tagline={items[2].tagline} />
          <CategoryCard to={`/category/corporate/${items[3].id}`} img={items[3].hero} title={items[3].title} tagline={items[3].tagline} />
          <CategoryCard to={`/category/corporate/${items[4].id}`} img={items[4].hero} title={items[4].title} tagline={items[4].tagline} />
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {items.slice(5).map(c => (
            <CategoryCard key={c.id} to={`/category/corporate/${c.id}`} img={c.hero} title={c.title} tagline={c.tagline} />
          ))}
        </div>
      </div>
    </section>
  );
};

export const PersonalCategoryGrid = ({ items }) => (
  <section className="py-16 md:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <div className="text-xs uppercase tracking-[0.24em] text-[#C58B76] mb-3">Personalised Gifting</div>
        <h2 className="font-serif-display text-4xl md:text-5xl text-[#2C2416] leading-tight">Gifts for the people you love</h2>
        <p className="text-[#5B4A3A] mt-4">Weddings, birthdays, baby showers and festivals - beautifully crafted, always personal.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {items.map(c => (
          <CategoryCard key={c.id} to={`/category/personal/${c.id}`} img={c.hero} title={c.title} tagline={c.tagline} />
        ))}
      </div>
    </div>
  </section>
);

export default CorporateCategoryGrid;
